import { render, staticRenderFns } from "./QrCodeReader.vue?vue&type=template&id=f30affcc"
import script from "./QrCodeReader.vue?vue&type=script&lang=js"
export * from "./QrCodeReader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports